import React from 'react';
import markianLogo from './markianLogo.svg';

const svgStyle = {
  width: '95px',
  height: '95px',
};

const MarkianCreatorIcon = () => (
  <>
    <img src={markianLogo} style={svgStyle} alt="smilesquad-logo" />
  </>
);

export default MarkianCreatorIcon;
